import { render } from "./Setting.vue?vue&type=template&id=43401871&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-43401871"

export default script